import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../commons/Auth';
import BurgerMenu from '../../commons/BurgerMenu';
import Header from '../../commons/Header';
import { ReactComponent as IconCalendar } from '../../images/icn-calendar.svg';
import variables from '../../variables';
import {
  BtnOutlineGreen,
  BtnOutlineRed,
  ContFilterYear,
  ContFlexBetween,
  ContPaginationPage,
  H4Styled,
} from '../../styled-components';
import {
  Button,
  Col,
  CustomInput,
  Form,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from 'reactstrap';
import generateYearOptions from '../../lib/helpers/generateYearOptions';
import generatePaginationOptions from '../../lib/helpers/generatePaginationOptions';
import Footer from '../../commons/Footer';
import ExtraInvoicesByMonthTable from './Table';

function ExtraInvoiceByMonthPresentational({
  data = [],
  total,
  query = {},
  onFilter,
  fetchIafsByMonthNetwork,
  onQueueJobRequestConfirm,
}) {
  const [t] = useTranslation();
  const [{ profile = {} } = {}] = useAuth();

  const [modal, setModal] = useState(false);

  const toggle = () => {
    setModal(!modal);
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    onQueueJobRequestConfirm();
    toggle();
  };

  return (
    <div className="App">
      <BurgerMenu />

      <div className="corpo">
        <section>
          <Header
            title={t('PAGES:EXTRA_IAF_BY_MONTH_NETWORK')}
            icon={<IconCalendar fill={variables.white} />}
          />
        </section>

        <Row className="mb-4">
          <Col>
            <Button onClick={toggle} target="_blank" color="primary">
              Richiesta emetti tutto
            </Button>
          </Col>
        </Row>

        <section>
          <Row>
            <Col sm="12" md="4" lg="4">
              <ContFilterYear className="no-width select-wrapper">
                <Row>
                  <Col xs="6">
                    <Label>{t('CONTACTS:USER_STATUS')}</Label>
                  </Col>
                  <Col xs="6">
                    <FormGroup>
                      <CustomInput
                        type="select"
                        id="selectProfileStatus"
                        name="profileStatus"
                        value={query.profileStatus || ''}
                        onChange={(e) =>
                          onFilter({ profileStatus: e.target.value })
                        }
                      >
                        <option value="">Tutti</option>
                        <option value="active">{t('COMMON:ACTIVE')}</option>
                        <option value="inactive">{t('COMMON:INACTIVE')}</option>
                      </CustomInput>
                    </FormGroup>
                  </Col>
                </Row>
              </ContFilterYear>
            </Col>

            <Col sm="12" md="4" lg="4">
              <ContFilterYear className="no-width select-wrapper">
                <Row>
                  <Col xs="6">
                    <Label>{t('COMMON:TITLE_FILTER_ACC_YEAR')}</Label>
                  </Col>
                  <Col xs="6">
                    <FormGroup>
                      <CustomInput
                        type="select"
                        id="selectYear"
                        name="year"
                        value={query.year}
                        onChange={({ target: { value: year } }) =>
                          onFilter({ year })
                        }
                      >
                        {generateYearOptions()}
                      </CustomInput>
                    </FormGroup>
                  </Col>
                </Row>
              </ContFilterYear>
            </Col>
          </Row>

          <br />

          <div className="table-responsive-by-month">
            <ExtraInvoicesByMonthTable
              data={data}
              total={total}
              query={query}
              onFilter={onFilter}
              fetchIafsByMonthNetwork={fetchIafsByMonthNetwork}
            />
          </div>

          <ContPaginationPage>
            <p>{t('COMMON:PAGINATION_PER_PAGE')}</p>

            <FormGroup>
              <CustomInput
                type="select"
                className="pagination-select"
                id="perPage"
                name="perPage"
                value={query.limit}
                onChange={({ target: { value: limit } }) => {
                  onFilter({ limit });
                }}
              >
                {generatePaginationOptions()}
              </CustomInput>
            </FormGroup>
          </ContPaginationPage>
        </section>

        <Modal isOpen={modal} toggle={toggle}>
          <ModalHeader toggle={toggle}>Richiesta di emissione</ModalHeader>
          <Form onSubmit={onSubmit}>
            <ModalBody>
              <div className="max-width-form" style={{ textAlign: 'center' }}>
                Vuoi richiedere l'emissione di tutte le IAF Network?
              </div>
            </ModalBody>
            <ModalFooter>
              <BtnOutlineRed
                type="button"
                className="uppercase"
                onClick={toggle}
              >
                {t('COMMON:CANCEL')}
              </BtnOutlineRed>
              <BtnOutlineGreen type="submit" className="uppercase">
                {t('COMMON:CONFIRM')}
              </BtnOutlineGreen>
            </ModalFooter>
          </Form>
        </Modal>

        <Footer />
      </div>
    </div>
  );
}

export default ExtraInvoiceByMonthPresentational;
